import { z } from 'zod';

/** Strict: unknown keys are rejected. The reason is recorded in the audit trail. */
export const cancelSubmissionRequestSchema = z.strictObject({
  reason: z.string().trim().min(1).max(2000),
});
export type CancelSubmissionRequest = z.infer<typeof cancelSubmissionRequestSchema>;
